import "./Organizations.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { BarLoader } from "react-spinners";
import { BaseURL } from "../../../Hooks/URL";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import { images } from "../../../Assets/assetsHelper";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../../../Components/Molecules/Filter/Filter";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import axios from "axios";
import { useCookies } from "react-cookie";
import { Box, Pagination } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "name",
    label: "Organization Name",
    minWidth: 100,
  },
  {
    id: "accounts",
    label: "Accounts",
    minWidth: 100,
  },
];

function Organizations({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  organizations,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  organizationsNumber,
}) {
  // const [cookies, setCookie] = useCookies(["TOKEN"]);
  return (
    <div className="mainContainer">
      <div className="cont">
        <h2 style={{ marginBottom: "20px" }}>
          Total Organizations: {organizationsNumber}
        </h2>
        {/* <div className="header">
          <Box sx={{ display: "flex" }}>
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search"}
              className="SearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search != searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13)
                  if (search != searchData) {
                    setSearch(searchData);
                  }
              }}
            />
            <Filter ageGroup categoryGroup paiedApp setFilter={setFilter} />
          </Box>
        </div> */}
        <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {organizations && !loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {organizations?.map((organization) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={organization.id}
                          style={{ cursor: "pointer" }}
                        >
                          {columns.map((column) => {
                            const value = organization[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id == "accounts"
                                  ? value?.map((account) => (
                                      <span
                                        style={{ textDecoration: "underline" }}
                                        onClick={() =>
                                          navigate(`/accounts/${account?.id}`)
                                        }
                                      >
                                        {account?.code},{" "}
                                      </span>
                                    ))
                                  : value ?? "-"}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!organizations?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No Organizations Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0 20px",
                  padding: "20px",
                  color: "var(--primary)",
                  "& .Mui-selected": {
                    backgroundColor: "var(--primary)",
                    color: "white",
                  },
                }}
              />
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default Organizations;
